import {ChangeDetectionStrategy, Component} from '@angular/core';

@Component({
  selector: 'spt-cancel-subscription-success',
  templateUrl: './cancel-subscription-success.component.html',
  styleUrls: ['./cancel-subscription-success.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CancelSubscriptionSuccessComponent {}
